// extracted by mini-css-extract-plugin
export default {"search":"Search_search__7QXvy","icon":"Search_icon__cTT8S"};